module.exports = __webpack_public_path__ + "static/media/snow-cat.fa3e7eae.mp4";